import React from 'react';

export const LogoLarge = () => {
	return (
		<span
			style={{ position: 'relative', height: '90%', maxWidth: '300px' }}
		>
			<svg
				id="logoLarge"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 529.85 93"
			>
				<circle
					id="LogoRing"
					className="logoLarge-1"
					cx="33.04"
					cy="33.04"
					r="31"
				/>
				<path
					id="LogoC"
					className="logoLarge-2"
					d="M50.35,51.11v6.52a12,12,0,0,0-3-2.81A5.83,5.83,0,0,0,44.26,54,6.08,6.08,0,0,0,39.66,56a6.83,6.83,0,0,0-1.83,4.86,7,7,0,0,0,1.77,4.91,5.94,5.94,0,0,0,4.55,1.92,6.22,6.22,0,0,0,3.12-.76A12.67,12.67,0,0,0,50.35,64v6.47a12.84,12.84,0,0,1-6,1.55,11.44,11.44,0,0,1-8.24-3.18,10.63,10.63,0,0,1-3.32-8,10.75,10.75,0,0,1,3.36-8,11.37,11.37,0,0,1,8.24-3.27A12.39,12.39,0,0,1,50.35,51.11Z"
					transform="translate(-21.88 -22.56)"
				/>
				<path
					id="LogoH"
					className="logoLarge-2"
					d="M56.26,34.6h4.9V52a8.45,8.45,0,0,1,5.78-2.35,7.45,7.45,0,0,1,5.76,2.33q1.83,2,1.83,6.47v13H69.62V58.87a6,6,0,0,0-.9-3.69A3.49,3.49,0,0,0,65.81,54a4,4,0,0,0-3.62,1.59q-1,1.62-1,5.54V71.43h-4.9Z"
					transform="translate(-21.88 -22.56)"
				/>
				<circle
					id="LogoDot"
					className="logoLarge-3"
					cx="22.62"
					cy="38.25"
					r="3.75"
				/>
				<text
					className="logoLarge-4"
					transform="translate(95.73 49.48)"
				>
					Change Impact <tspan className="logoLarge-6">Plus</tspan>
				</text>
				<text
					className="logoLarge-7"
					transform="translate(354.94 86.07)"
				>
					Constituent
				</text>
				<text
					className="logoLarge-8"
					transform="translate(476.59 86.07)"
				>
					Hub
				</text>
				<text
					className="logoLarge-9"
					transform="translate(333.37 86.07)"
				>
					by
				</text>
			</svg>
		</span>
	);
};
